// src/components/utils/sound.ts
let audioCtx: AudioContext | null = null;

export function getAudioContext() {
    if (typeof window === "undefined") return null;
    if (!audioCtx) {
        audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
    }
    return audioCtx;
}

export async function unlockAudio() {
    const ctx = getAudioContext();
    if (!ctx) return;
    if (ctx.state === "suspended") {
        try { await ctx.resume(); } catch {}
    }
}

// 👇 neu: Helper, ob Sound erlaubt ist (Default: true)
function isSoundEnabled(): boolean {
    if (typeof window === "undefined") return true;
    try {
        const v = window.localStorage.getItem("soundEnabled");
        return v === null ? true : v === "true";
    } catch {
        return true;
    }
}

/**
 * Spielt einen kurzen Beep mit sanfter Hüllkurve (kein Knacksen).
 */
export function playBeep(freq = 660, durationMs = 140, volume = 0.25) {
    // 👇 hier global muten
    if (!isSoundEnabled()) return;

    const ctx = getAudioContext();
    if (!ctx) return;

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = "sine";
    osc.frequency.value = freq;

    const now = ctx.currentTime;
    const dur = durationMs / 1000;
    const attack = 0.005;
    const release = 0.06;

    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(volume, now + attack);
    gain.gain.setValueAtTime(volume, now + dur - release);
    gain.gain.linearRampToValueAtTime(0.0001, now + dur);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + dur);
}
